import {
  AddressBook,
  ApplicationOne,
  BookOne,
  BuildingOne,
  Certificate,
  Classroom,
  CommentOne,
  Editor,
  Help,
  Mark,
  People,
  Permissions,
  Protect,
  RedEnvelope,
  Schedule,
  SettingTwo,
  ShoppingBag,
  Star,
  TopicDiscussion,
  TransactionOrder,
  User,
  Workbench,
  Zijinyunying,
} from '@icon-park/vue-next';

/**
 * 用户路由
 */
const routerUser = {
  path: '/user',
  name: 'User',
  meta: {
    title: '用户中心',
    needLogin: true,
    transitionName: 'router',
  },
  component: () => import('@/pages/module-user/index.vue'),
  children: [
    {
      path: 'user-my-info',
      name: 'UserMyInfo',
      meta: {
        title: '个人资料',
        needLogin: true,
        transitionName: '',
        icon: People,
      },
      component: () => import('@/pages/module-user/user-my-info/index.vue'),
      children: [
        {
          path: 'my-baseInfo',
          name: 'UserMyInfoData',
          meta: {
            title: '个人资料',
            needLogin: true,
            transitionName: '',
            icon: User,
          },
          component: () => import('@/pages/module-user/user-my-info/MyInfoData.vue'),
        },
        {
          path: 'my-account-authentication',
          name: 'UserMyInfoUserAccountAuthentication',
          meta: {
            title: '账号认证',
            needLogin: true,
            transitionName: '',
            icon: Protect,
          },
          component: () => import('@/pages/module-user/user-my-info/UserAccountAuthentication.vue'),
        },
        {
          path: 'my-role-authentication',
          name: 'UserMyInfoUserRoleAuthentication',
          meta: {
            title: '角色认证',
            needLogin: true,
            transitionName: '',
            icon: Permissions,
          },
          component: () => import('@/pages/module-user/user-my-info/UserRoleAuthentication/index.vue'),
        },
        // {
        //   path: 'my-expert-info',
        //   name: 'UserMyInfoExpert',
        //   meta: {
        //     title: '专家主页管理',
        //     needLogin: true,
        //     transitionName: '',
        //     icon: UserBusiness,
        //   },
        //   component: () => import('@/pages/module-user/user-my-info/MyInfoExpert.vue'),
        // },
      ],
    },
    {
      path: 'user-activity-manage',
      name: 'UserActivityManage',
      meta: {
        title: '学考中心',
        needLogin: true,
        transitionName: '',
        icon: Mark,
      },
      component: () => import('@/pages/module-user/user-activity-manage/index.vue'),
      children: [
        {
          path: 'my-course',
          name: 'UserActivityManageMyCourse',
          meta: {
            title: '我的课程',
            needLogin: true,
            transitionName: '',
            icon: Classroom,
          },
          component: () => import('@/pages/module-user/user-activity-manage/ActivityManageMyCourse.vue'),
        },
        {
          path: 'my-approve',
          name: 'UserActivityManageMyApprove',
          meta: {
            title: '我的认证',
            needLogin: true,
            transitionName: '',
            icon: Certificate,
          },
          component: () => import('@/pages/module-user/user-activity-manage/ActivityManageMyApprove.vue'),
        },
        {
          path: 'my-train',
          name: 'UserActivityManageMyTrain',
          meta: {
            title: '我的培训',
            needLogin: true,
            transitionName: '',
            icon: ApplicationOne,
          },
          component: () => import('@/pages/module-user/user-activity-manage/ActivityManageMyTrain.vue'),
        },
        // {
        //   path: 'my-reward',
        //   name: 'UserActivityManageMyReward',
        //   meta: {
        //     title: '我的榜单',
        //     needLogin: true,
        //     transitionName: '',
        //     icon: Editor,
        //   },
        //   component: () => import('@/pages/module-user/user-activity-manage/ActivityManageMyReward.vue'),
        //   redirect: () => {
        //     return {
        //       name: 'UserActivityManageMyRewardList',
        //     };
        //   },
        //   children: [
        //     {
        //       path: 'my-reward-list',
        //       name: 'UserActivityManageMyRewardList',
        //       meta: {
        //         title: '我的榜单',
        //         needLogin: true,
        //         transitionName: '',
        //       },
        //       component: () => import('@/pages/module-user/user-activity-manage/ActivityManageMyRewardList.vue'),
        //     },
        //     {
        //       path: 'my-reward-list',
        //       name: 'UserActivityManageMyRewardDetail',
        //       meta: {
        //         title: '榜单详情',
        //         needLogin: true,
        //         transitionName: '',
        //       },
        //       component: () => import('@/pages/module-user/user-activity-manage/ActivityManageMyRewardDetail.vue'),
        //     },
        //   ],
        // },
        {
          path: 'my-competition',
          name: 'UserActivityManageMyCompetition',
          meta: {
            title: '我的竞赛',
            needLogin: true,
            transitionName: '',
            icon: ApplicationOne,
          },
          component: () => import('@/pages/module-user/user-activity-manage/ActivityManageMyCompetition.vue'),
        },
      ],
    },
    {
      path: 'user-build-center',
      name: 'UserBuildCenter',
      meta: {
        title: '我的Club',
        needLogin: true,
        transitionName: '',
        icon: Workbench,
      },
      component: () => import('@/pages/module-user/user-build-center/index.vue'),
      children: [
        {
          path: 'my-article',
          name: 'UserBuildCenterMyArticle',
          meta: {
            title: '我的文章',
            needLogin: true,
            transitionName: '',
            icon: Editor,
          },
          component: () => import('@/pages/module-user/user-build-center/BuildCenterMyArticle.vue'),
          redirect: () => {
            return {
              name: 'UserBuildCenterMyArticleList',
            };
          },
          children: [
            {
              path: 'article-list',
              name: 'UserBuildCenterMyArticleList',
              meta: {
                title: '文章列表',
                needLogin: true,
                transitionName: '',
              },
              component: () => import('@/pages/module-user/user-build-center/BuildCenterMyArticleList.vue'),
            },
            {
              path: 'article-form',
              name: 'UserBuildCenterMyArticleForm',
              meta: {
                title: '发布文章',
                needLogin: true,
                transitionName: '',
              },
              component: () => import('@/pages/module-user/user-build-center/BuildCenterMyArticleForm.vue'),
            },
            {
              path: 'article-detail',
              name: 'UserBuildCenterMyArticleDetail',
              meta: {
                title: '文章详情',
                needLogin: true,
                transitionName: '',
              },
              component: () => import('@/pages/module-user/user-build-center/ArticleDetail.vue'),
            },
          ],
        },
        {
          path: 'my-question',
          name: 'UserBuildCenterMyQuestion',
          meta: {
            title: '我的提问',
            needLogin: true,
            transitionName: '',
            icon: Help,
          },
          component: () => import('@/pages/module-user/user-build-center/BuildCenterMyQuestion.vue'),
          redirect: () => {
            return {
              name: 'UserBuildCenterMyQuestionList',
            };
          },
          children: [
            {
              title: '我的提问',
              path: 'my-question-list',
              name: 'UserBuildCenterMyQuestionList',
              component: () => import('@/pages/module-user/user-build-center/BuildCenterMyQuestionList.vue'),
            },
            {
              title: '提问详情',
              path: 'my-question-detail',
              name: 'UserBuildCenterMyQuestionDetail',
              component: () => import('@/pages/module-user/user-build-center/QuestionDetail.vue'),
            },
          ],
        },
        {
          path: 'interact-response',
          name: 'UserBuildCenterInteractResponse',
          meta: {
            title: '互动回复',
            needLogin: true,
            transitionName: '',
            icon: CommentOne,
          },
          component: () => import('@/pages/module-user/user-build-center/BuildCenterInteractResponse.vue'),
          redirect: () => {
            return {
              name: 'UserBuildCenterInteractResponseList',
            };
          },
          children: [
            {
              path: 'interact-response-list',
              name: 'UserBuildCenterInteractResponseList',
              meta: {
                title: '互动回复',
                needLogin: true,
                transitionName: '',
              },
              component: () => import('@/pages/module-user/user-build-center/BuildCenterInteractResponseList.vue'),
            },
            {
              path: 'my-interact-response-article-detail',
              title: '文章详情',
              name: 'UserBuildCenterInteractResponseArticleDetail',
              component: () => import('@/pages/module-user/user-build-center/ArticleDetail.vue'),
            },
            {
              path: 'my-interact-response-question-detail',
              title: '问题详情',
              name: 'UserBuildCenterInteractResponseQuestionDetail',
              component: () => import('@/pages/module-user/user-build-center/QuestionDetail.vue'),
            },
          ],
        },
        {
          path: 'my-collect',
          name: 'UserBuildCenterMyCollect',
          meta: {
            title: '我的收藏',
            needLogin: true,
            transitionName: '',
            icon: Star,
          },
          component: () => import('@/pages/module-user/user-build-center/BuildCenterMyCollect.vue'),
          redirect: () => {
            return {
              name: 'UserBuildCenterMyCollectList',
            };
          },
          children: [
            {
              path: 'my-collect-list',
              title: '我的收藏',
              name: 'UserBuildCenterMyCollectList',
              component: () => import('@/pages/module-user/user-build-center/BuildCenterMyCollectList.vue'),
            },
            {
              path: 'my-collect-article-detail',
              title: '文章详情',
              name: 'UserBuildCenterMyCollectArticleDetail',
              component: () => import('@/pages/module-user/user-build-center/ArticleDetail.vue'),
            },
            {
              path: 'my-collect-question-detail',
              title: '问题详情',
              name: 'UserBuildCenterMyCollectQuestionDetail',
              component: () => import('@/pages/module-user/user-build-center/QuestionDetail.vue'),
            },
          ],
        },
        {
          path: 'my-reward',
          name: 'UserBuildCenterReward',
          meta: {
            title: '我的需求',
            needLogin: true,
            transitionName: '',
            icon: TransactionOrder,
          },
          component: () => import('@/pages/module-user/user-build-center/BuildCenterReward.vue'),
          redirect: () => {
            return {
              name: 'UserBuildCenterRewardList',
            };
          },
          children: [
            {
              path: 'my-reward-list',
              name: 'UserBuildCenterRewardList',
              meta: {
                title: '需求列表',
                needLogin: true,
                transitionName: '',
              },
              component: () => import('@/pages/module-user/user-build-center/BuildCenterRewardIndex.vue'),
            },
            {
              path: 'my-reward-issue',
              name: 'UserBuildCenterRewardIssue',
              meta: {
                title: '发布需求',
                needLogin: true,
                transitionName: '',
              },
              component: () => import('@/pages/module-user/user-build-center/BuildCenterRewardIssue.vue'),
            },
            {
              path: 'my-reward-detail',
              name: 'UserBuildCenterRewardDetail',
              meta: {
                title: '需求详情',
                needLogin: true,
                transitionName: '',
              },
              component: () => import('@/pages/module-user/user-build-center/BuildCenterRewardDetail.vue'),
            },
            {
              path: 'reward-detail',
              name: 'UserBuildCenterRewardDetail2',
              meta: {
                title: '需求详情',
                needLogin: true,
                transitionName: '',
              },
              component: () => import('@/pages/module-user/user-build-center/BuildCenterRewardDetail.vue'),
            },
          ],
        },
        {
          // 优惠福利
          path: 'my-welfare',
          name: 'UserBuildCenterWelfare',
          meta: {
            title: '优惠福利',
            needLogin: true,
            transitionName: '',
            icon: RedEnvelope,
          },
          component: () => import('@/pages/module-user/user-build-center/BuildCenterWelfare.vue'),
        },
        // {
        //   // 我的成果
        //   path: 'my-achievement',
        //   name: 'UserBuildCenterAchievement',
        //   meta: {
        //     title: '我的成果',
        //     needLogin: true,
        //     transitionName: '',
        //     icon: <ApplicationOne />,
        //   },
        //   component: () => import('@/pages/module-user/user-build-center/BuildCenterAchievement.vue'),
        // },
        // 我的活动
        // {
        //   path: 'my-activity',
        //   name: 'UserBuildCenterActivity',
        //   meta: {
        //     title: '我的活动',
        //     needLogin: true,
        //     transitionName: '',
        //     icon: ActivitySource,
        //   },
        //   component: () => import('@/pages/module-user/user-build-center/BuildCenterActivity.vue'),
        // },
        // 我的关注
        // {
        //   path: 'my-follow',
        //   name: 'UserBuildCenterFollow',
        //   meta: {
        //     title: '我关注的',
        //     needLogin: true,
        //     transitionName: '',
        //     icon: Concern,
        //   },
        //   component: () => import('@/pages/module-user/user-build-center/BuildCenterFollow.vue'),
        // },
      ],
    },
    {
      path: 'user-course-dev',
      name: 'UserCourseDev',
      meta: {
        title: '课程开发',
        needLogin: true,
        isLecturerAuthed: true,
        transitionName: '',
        icon: Workbench,
      },
      component: () => import('@/pages/module-user/user-course-dev/index.vue'),
      children: [
        {
          path: 'single-course',
          name: 'UserCourseDevSingleCourse',
          meta: {
            title: '视频管理',
            needLogin: true,
            transitionName: '',
            icon: Schedule,
          },
          component: () => import('@/pages/module-user/user-course-dev/SingleCourse.vue'),
        },
        {
          path: 'course-manage',
          name: 'UserCourseDevCourseManage',
          meta: {
            title: '课程管理',
            needLogin: true,
            transitionName: '',
            icon: Classroom,
          },
          component: () => import('@/pages/module-user/user-course-dev/CourseManage.vue'),
        },
        {
          path: 'question-bank',
          name: 'UserCourseDevQuestionBank',
          meta: {
            title: '题库管理',
            needLogin: true,
            transitionName: '',
            icon: TopicDiscussion,
          },
          component: () => import('@/pages/module-user/user-course-dev/QuestionBank.vue'),
        },
        {
          path: 'operating-revenue',
          name: 'UserCourseDevOperatingRevenue',
          meta: {
            title: '运营收益',
            needLogin: true,
            transitionName: '',
            icon: Zijinyunying,
          },
          component: () => import('@/pages/module-user/user-course-dev/OperatingRevenue.vue'),
        },
      ],
    },
    {
      path: 'user-my-order',
      name: 'UserMyOrder',
      meta: {
        title: '订单管理',
        needLogin: true,
        transitionName: '',
        icon: ShoppingBag,
      },
      component: () => import('@/pages/module-user/user-my-order/index.vue'),
    },
    {
      path: 'user-enterprise-centre',
      name: 'UserEnterpriseCentre',
      meta: {
        title: '企业中心',
        needLogin: true,
        transitionName: '',
        enterpriseAuthed: true,
        icon: People,
      },
      component: () => import('@/pages/module-user/user-enterprise-centre/index.vue'),
      children: [
        {
          path: 'enterprise-info',
          name: 'enterpriseInfo',
          meta: {
            title: '企业信息',
            needLogin: true,
            transitionName: '',
            icon: BuildingOne,
          },
          component: () => import('@/pages/module-user/user-enterprise-centre/enterpriseInfo.vue'),
        },
        {
          path: 'staff-manage',
          name: 'staffManage',
          meta: {
            title: '职员管理',
            needLogin: true,
            transitionName: '',
            icon: AddressBook,
          },
          component: () => import('@/pages/module-user/user-enterprise-centre/staffManage.vue'),
        },
        {
          path: 'tool-manage',
          name: 'toolManage',
          meta: {
            title: '工具管理',
            needLogin: true,
            transitionName: '',
            icon: SettingTwo,
          },
          component: () => import('@/pages/module-user/user-enterprise-centre/toolManage.vue'),
        },
        {
          path: 'enterprise-resource',
          name: 'enterpriseResource',
          meta: {
            title: '企业资源',
            needLogin: true,
            transitionName: '',
            icon: BookOne,
          },
          component: () => import('@/pages/module-user/user-enterprise-centre/enterpriseResource.vue'),
        },

      ],
    },
  ],
};

export default routerUser;
